export enum CLOTHESTYPE {
  JACKE,
  AGT_HOSE,
  BUNDHOSE,
  LATZHOSE,
}
